import { render, staticRenderFns } from "./Estadistica_Mensual.vue?vue&type=template&id=ede28a32"
import script from "./Estadistica_Mensual.vue?vue&type=script&lang=js"
export * from "./Estadistica_Mensual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports